import React, { Component, Fragment } from "react";
import { FormattedMessage } from "react-intl";
import PropTypes from "prop-types";

class HumanModal extends Component {
  static propTypes = {
    onClose: PropTypes.func.isRequired
  };
  render() {
    const { onClose } = this.props;
    return (
      <Fragment>
        <div className="human-modal">
          <div className="human-text">
            <p>
              <FormattedMessage id="human.select-zones" />
            </p>
            <p>
              <FormattedMessage id="human.select-zones-desctiption" />
            </p>
          </div>
          <div className="human-button">
            <button className="ok-button" onClick={() => onClose(false)}>
              <FormattedMessage id="human.ok-button" />
            </button>
          </div>
        </div>
      </Fragment>
    );
  }
}

export default HumanModal;



// WEBPACK FOOTER //
// ./src/modules/modal/human-modal.js